<div class="jumbotron">
    <h3>{{title}}</h3>
    <p>{{message}}</p>
    
    <div style="text-align: center;">
        <button mat-stroked-button routerLinkActive="active" [routerLink]="['/login']">Go back to login</button>
    </div>
</div>